var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFpaHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.544 4.597a1 1 0 0 1-1-1V1.8a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1V16a1 1 0 0 0 1 1h10.34a1 1 0 0 0 1-1V5.597a1 1 0 0 0-1-1H9.544zM3.68 7.917a1 1 0 0 1 1.414 0l.712.712a.916.916 0 0 0 1.296 0l1.1-1.101a.271.271 0 0 0-.192-.463.271.271 0 0 1-.271-.27V6.59c0-.262.212-.474.475-.474h1.069a1 1 0 0 1 1 1v1.08a.475.475 0 0 1-.475.475h-.202a.273.273 0 0 1-.273-.273.273.273 0 0 0-.466-.193L7.163 9.913a1 1 0 0 1-1.415 0l-.653-.653a1 1 0 0 0-1.414 0l-.632.632a.475.475 0 1 1-.671-.672L3.68 7.918zm6.637 6.047a.475.475 0 0 1-.474.475H2.526a.475.475 0 0 1 0-.95h7.318c.262 0 .474.213.474.475zm0-1.898a.475.475 0 0 1-.474.474H2.526a.475.475 0 0 1 0-.949h7.318c.262 0 .474.213.474.475z",
    fill: "#8E8EA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpaHeaderIcon);
export default __webpack_public_path__ + "static/media/FPAHeader__Icon.0388c71e70c7bc9fe8736bd83b0d51c4.svg";
export { ForwardRef as ReactComponent };